const $$splitComponentImporter = () => import('/Users/xpress/Code/knrt/jgxt/projects/jgxt/ui/web/src/routes/console/_auth/_layout/institution-agent.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { type AIPatrolCandidate, type AIPatrolLevelOverview, type AIPatrolStatus } from '@/api/ai-patrol';
// region 路由与筛选

// 筛选放在 URL 上: 刷新不丢、退回列表能还原; 字段全部可选, 菜单直接跳进来时用默认值
interface PatrolSearch {
  set?: string;
  level?: AIPatrolLevel;
  status?: AIPatrolStatus | 'all';
  platform?: 'yes' | 'no';
  keyword?: string;
  pageNo?: number;
  pageSize?: number;
}
export const Route = createFileRoute('/console/_auth/_layout/institution-agent')({
  validateSearch: (search: Record<string, unknown>): PatrolSearch => ({
    set: typeof search.set === 'string' ? search.set : undefined,
    level: search.level === 'high' || search.level === 'medium' || search.level === 'low' ? search.level : undefined,
    status: search.status === 'invited' || search.status === 'all' ? search.status : undefined,
    platform: search.platform === 'yes' || search.platform === 'no' ? search.platform : undefined,
    keyword: typeof search.keyword === 'string' ? search.keyword : undefined,
    pageNo: Number(search.pageNo) || undefined,
    pageSize: Number(search.pageSize) || undefined
  }),
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});

// 级别的颜色; 显示名按集合定, 从概览里取

// endregion

// region 详情

// CandidateDetail 当前集合命中的每条规则和证据; 只显示当前集合, 不显示这个人在其他集合里的结果

// endregion

// region 小组件

// LevelPill 级别标签: 显示名按集合定, 从概览的级别列表里取

// endregion

// region 格式化
// endregion
if (import.meta.hot) {
  import.meta.hot.accept(newModule => {
    if (newModule && newModule.Route && typeof newModule.Route.clone === 'function') {
      newModule.Route.clone(Route);
    }
  });
}